// extracted by mini-css-extract-plugin
module.exports = {"footer":"index-footer-1jI95","footerInner":"index-footerInner-1r1zL"};